import { apiClient } from '@/shared/lib/axios';
import { InsurerQuery } from '@/types/admin-insurer';
import { useMutation } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import useAppToast from '../useAppToast';
import { getApiErrorMessage } from '@/utils';
import { japaneseDateToISO } from '@/utils/dateConverter';

export const downloadInsurersCsv = async (
  siteType: string | null,
  query?: InsurerQuery
): Promise<void> => {
  const formattedQuery = query
    ? {
        ...query,
        available_date: query.available_date ? japaneseDateToISO(query.available_date) : undefined,
      }
    : undefined;

  const response = await apiClient.get(`/admin/${siteType}/insurers/csv`, {
    params: formattedQuery,
    responseType: 'blob',
  });

  const blob = response.data;
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = `insurer${new Date().toISOString().slice(0, 10).replace(/-/g, '')}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const useDownloadInsurersCsv = () => {
  const { site } = useParams<{ site: string }>();
  const currentSite = site ?? 'medix';
  const toast = useAppToast();

  return useMutation({
    mutationFn: (query?: InsurerQuery) => downloadInsurersCsv(currentSite, query),
    onSuccess: () => {
      toast.success('CSVを出力しました。');
    },
    onError: err => {
      toast.error(getApiErrorMessage(err, 'CSVの出力に失敗しました。'));
    },
  });
};
